import { TEXT_COMPONENTS } from "@tfg/types/schemas/communication-studio/components"

import {
  getProductPageComponentsResponseDtoComponentTypeEnum,
  GetProductPageComponentsResponseDtoComponentTypeEnumKey,
} from "~/gen/api/types/GetProductPageComponentsResponseDto"

export const isComponentEditable = (
  componentType: GetProductPageComponentsResponseDtoComponentTypeEnumKey
): boolean => {
  const editableComponents = [
    getProductPageComponentsResponseDtoComponentTypeEnum.BULLETED_LIST,
    getProductPageComponentsResponseDtoComponentTypeEnum.TEXT_PARAGRAPH_V2,
    getProductPageComponentsResponseDtoComponentTypeEnum.LOGO,
    getProductPageComponentsResponseDtoComponentTypeEnum.PRODUCT_ATTRIBUTES,
    ...TEXT_COMPONENTS,
  ]

  return editableComponents.includes(componentType)
}
